import { blogArticleTranslations } from "../i18n/blogArticleTranslations";
import { getLocalizedTag, getLocalizedTags } from "../i18n/blogTagTranslations";

const phraseTranslations = {
  住所: { EN: "Address", 中文: "地址", 한국어: "주소" },
  電話: { EN: "Phone", 中文: "电话", 한국어: "전화" },
  アクセス: { EN: "Access", 中文: "交通", 한국어: "가는 길" },
  ジャンル: { EN: "Genre", 中文: "类型", 한국어: "장르" },
  映え度: { EN: "Photo Score", 中文: "上镜度", 한국어: "사진 점수" },
  おすすめメニュー: {
    EN: "Recommended Menu",
    中文: "推荐菜单",
    한국어: "추천 메뉴",
  },
  営業時間: { EN: "Hours", 中文: "营业时间", 한국어: "영업시간" },
  定休日: { EN: "Closed", 中文: "休息日", 한국어: "정기휴무" },
  最寄り空港: { EN: "Nearest Airport", 中文: "最近机场", 한국어: "가까운 공항" },
  "一泊あたりの目安（時期により変動）": {
    EN: "Price per Night (varies by season)",
    中文: "每晚参考价格（因季节而异）",
    한국어: "1박 기준 가격（시즌에 따라 변동）",
  },
  オーシャンビュー: { EN: "Ocean View", 中文: "海景", 한국어: "오션뷰" },
  対応言語: {
    EN: "Languages Spoken",
    中文: "可用语言",
    한국어: "가능 언어",
  },
  "設備・サービス": { EN: "Facilities", 中文: "设施与服务", 한국어: "시설·서비스" },
  駐車場: { EN: "Parking", 中文: "停车场", 한국어: "주차장" },
  屋外プール: { EN: "Outdoor Pool", 中文: "户外泳池", 한국어: "야외 수영장" },
  室内プール: { EN: "Indoor Pool", 中文: "室内泳池", 한국어: "실내 수영장" },
  ダイビング: { EN: "Diving", 中文: "潜水", 한국어: "다이빙" },
  シュノーケリング: {
    EN: "Snorkeling",
    中文: "浮潜",
    한국어: "스노클링",
  },
  スパ: { EN: "Spa", 中文: "水疗", 한국어: "스파" },
  マッサージ: { EN: "Massage", 中文: "按摩", 한국어: "마사지" },
  手荷物預かり: {
    EN: "Luggage Storage",
    中文: "行李寄存",
    한국어: "짐 보관",
  },
  レンタカー: { EN: "Car Rental", 中文: "租车", 한국어: "렌터카" },
  サウナ: { EN: "Sauna", 中文: "桑拿", 한국어: "사우나" },
  キッズクラブ: { EN: "Kids Club", 中文: "儿童俱乐部", 한국어: "키즈클럽" },
  送迎: { EN: "Shuttle Service", 中文: "接送服务", 한국어: "셔틀 서비스" },
  コインランドリー: {
    EN: "Coin Laundry",
    中文: "投币洗衣",
    한국어: "코인 세탁실",
  },
  マッサージルーム: { EN: "Massage Room", 中文: "按摩室", 한국어: "마사지룸" },
  ジム: { EN: "Gym", 中文: "健身房", 한국어: "헬스장" },
  ゴルフ場: { EN: "Golf Course", 中文: "高尔夫球场", 한국어: "골프장" },
  温泉: { EN: "Hot Spring", 中文: "温泉", 한국어: "온천" },
  露天風呂: { EN: "Outdoor Bath", 中文: "露天风吕", 한국어: "노천탕" },
  エステ施設: {
    EN: "Spa Treatment",
    中文: "美容护理设施",
    한국어: "에스테틱 시설",
  },
  ペット可: { EN: "Pets Allowed", 中文: "可携宠物", 한국어: "반려동물 동반 가능" },
  プライベートビーチエリア: {
    EN: "Private Beach Area",
    中文: "私人海滩区域",
    한국어: "프라이빗 비치 구역",
  },
  サーフィン: { EN: "Surfing", 中文: "冲浪", 한국어: "서핑" },
  禁煙ルーム: { EN: "Non-Smoking Room", 中文: "禁烟房", 한국어: "금연룸" },
  "禁煙（共用エリア）": {
    EN: "Non-Smoking (Common Areas)",
    中文: "禁烟（公共区域）",
    한국어: "금연（공용구역）",
  },
  ファミリールーム: { EN: "Family Room", 中文: "家庭房", 한국어: "패밀리룸" },
  衣類乾燥機: { EN: "Clothes Dryer", 中文: "烘干机", 한국어: "의류 건조기" },
  衣類スチーマー: {
    EN: "Garment Steamer",
    中文: "挂烫机",
    한국어: "의류 스티머",
  },
  ビーチフロント: { EN: "Beachfront", 中文: "海滩前", 한국어: "비치프런트" },
  現地ツアー予約サービス: {
    EN: "Local Tour Booking Service",
    中文: "当地旅游预约服务",
    한국어: "현지 투어 예약 서비스",
  },
  ジャグジー: { EN: "Jacuzzi", 中文: "按摩浴缸", 한국어: "자쿠지" },
  ゲームルーム: { EN: "Game Room", 中文: "游戏室", 한국어: "게임룸" },
  カラオケ: { EN: "Karaoke", 中文: "卡拉OK", 한국어: "노래방" },
  ルームサービス: { EN: "Room Service", 中文: "客房服务", 한국어: "룸서비스" },
  客室数: { EN: "Number of Rooms", 中文: "客房数", 한국어: "객실 수" },
  下地島空港: {
    EN: "Shimojishima Airport",
    中文: "下地岛机场",
    한국어: "시모지시마 공항",
  },
  宮古空港: { EN: "Miyako Airport", 中文: "宫古机场", 한국어: "미야코 공항" },
  全室オーシャンビュー: {
    EN: "All rooms have an ocean view",
    中文: "全部客房均为海景",
    한국어: "전객실 오션뷰",
  },
  一部客室がオーシャンビュー: {
    EN: "Some rooms have an ocean view",
    中文: "部分客房为海景",
    한국어: "일부 객실 오션뷰",
  },
  オーシャンビューなし: {
    EN: "No ocean view",
    中文: "无海景",
    한국어: "오션뷰 없음",
  },
  "全室オーシャンビュー（全55棟・プライベートプール付き）": {
    EN: "All 55 villas have an ocean view and a private pool",
    中文: "全55栋均为海景，且带私人泳池",
    한국어: "전 55동 오션뷰・프라이빗 풀 완비",
  },
  "一部客室がオーシャンビュー（シギラオーシャンスイート等）": {
    EN: "Some rooms have an ocean view (e.g. Shigira Ocean Suite)",
    中文: "部分客房为海景（如系拉海景套房等）",
    한국어: "일부 객실 오션뷰（시기라 오션스위트 등）",
  },
  "一部客室がオーシャンビュー（首里ハウス棟）": {
    EN: "Some rooms have an ocean view (Shuri House wing)",
    中文: "部分客房为海景（首里屋栋）",
    한국어: "일부 객실 오션뷰（슈리 하우스동）",
  },
  "5室": { EN: "5 rooms", 中文: "5间", 한국어: "5실" },
  "Trip.comで空室・料金を見る": {
    EN: "Check availability on Trip.com",
    中文: "在Trip.com查看空房与价格",
    한국어: "Trip.com에서 빈 객실・요금 보기",
  },
  "Booking.comで空室・料金を見る": {
    EN: "Check availability on Booking.com",
    中文: "在Booking.com查看空房与价格",
    한국어: "Booking.com에서 빈 객실・요금 보기",
  },
  "楽天トラベルで空室・料金を見る": {
    EN: "Check availability on Rakuten Travel",
    中文: "在乐天旅游查看空房与价格",
    한국어: "라쿠텐 트래블에서 빈 객실・요금 보기",
  },
  "Yahoo!トラベルで空室・料金を見る": {
    EN: "Check availability on Yahoo! Travel",
    中文: "在Yahoo!旅游查看空房与价格",
    한국어: "Yahoo! 트래블에서 빈 객실・요금 보기",
  },
  リゾートホテル: { EN: "Resort Hotel", 中文: "度假酒店", 한국어: "리조트 호텔" },
  オーベルジュリゾート: {
    EN: "Auberge Resort",
    中文: "美食旅宿型度假村",
    한국어: "오베르주 리조트",
  },
  ラグジュアリーヴィラ: {
    EN: "Luxury Villa",
    中文: "豪华别墅",
    한국어: "럭셔리 빌라",
  },
  オールヴィラリゾート: {
    EN: "All-Villa Resort",
    中文: "全别墅型度假村",
    한국어: "올 빌라 리조트",
  },
  一棟貸しヴィラ: {
    EN: "Whole-Villa Rental",
    中文: "整栋出租别墅",
    한국어: "한 채 통대여 빌라",
  },
  ラグジュアリーホテル: {
    EN: "Luxury Hotel",
    中文: "豪华酒店",
    한국어: "럭셔리 호텔",
  },
  オールスイートリゾート: {
    EN: "All-Suite Resort",
    中文: "全套房型度假村",
    한국어: "올 스위트 리조트",
  },
  オールスイートホテル: {
    EN: "All-Suite Hotel",
    中文: "全套房型酒店",
    한국어: "올 스위트 호텔",
  },
  ヴィラリゾート: { EN: "Villa Resort", 中文: "别墅度假村", 한국어: "빌라 리조트" },
  貸別荘: {
    EN: "Private Vacation House",
    中文: "出租别墅",
    한국어: "대여 별장",
  },
  テーマ別ヴィラ: {
    EN: "Themed Villa",
    中文: "主题别墅",
    한국어: "테마별 빌라",
  },
  隠れ家リゾート: {
    EN: "Hideaway Resort",
    中文: "隐世度假村",
    한국어: "은신처 리조트",
  },
  大型リゾートホテル: {
    EN: "Large Resort Hotel",
    中文: "大型度假酒店",
    한국어: "대형 리조트 호텔",
  },
  デザイナーズホテル: {
    EN: "Designer Hotel",
    中文: "设计师酒店",
    한국어: "디자이너 호텔",
  },
  美食リゾート: {
    EN: "Gourmet Resort",
    中文: "美食度假村",
    한국어: "미식 리조트",
  },
  伊良部島: { EN: "Irabu Island", 中文: "伊良部岛", 한국어: "이라부섬" },
  "伊良部島 佐和田": {
    EN: "Irabu Island, Sawada",
    中文: "伊良部岛 佐和田",
    한국어: "이라부섬 사와다",
  },
  "伊良部島 渡口の浜周辺": {
    EN: "Irabu Island, near Toguchi Beach",
    中文: "伊良部岛 渡口海滩周边",
    한국어: "이라부섬 토구치 해변 주변",
  },
  シギラ: { EN: "Shigira", 中文: "系拉", 한국어: "시기라" },
  "シギラ / インギャー": {
    EN: "Shigira / Ingya",
    中文: "系拉／因加",
    한국어: "시기라 / 인갸",
  },
  インギャー: { EN: "Ingya", 中文: "因加", 한국어: "인갸" },
  上野: { EN: "Ueno", 中文: "上野", 한국어: "우에노" },
  "宮古島北部（大浦湾）": {
    EN: "Northern Miyakojima (Oura Bay)",
    中文: "宫古岛北部（大浦湾）",
    한국어: "미야코지마 북부（오우라만）",
  },
  "平良（サンセットビーチ隣接）": {
    EN: "Hirara (next to Sunset Beach)",
    中文: "平良（毗邻日落海滩）",
    한국어: "히라라（선셋비치 인접）",
  },
  "宮古島北部（荷川取）": {
    EN: "Northern Miyakojima (Nikadori)",
    中文: "宫古岛北部（荷川取）",
    한국어: "미야코지마 북부（니카도리）",
  },
  来間島: { EN: "Kurima Island", 中文: "来间岛", 한국어: "쿠리마섬" },
  与那覇湾周辺: {
    EN: "Around Yonaha Bay",
    中文: "与那覇湾周边",
    한국어: "요나하만 주변",
  },
  宮古島南部: {
    EN: "Southern Miyakojima",
    中文: "宫古岛南部",
    한국어: "미야코지마 남부",
  },
  日本語: { EN: "Japanese", 中文: "日语", 한국어: "일본어" },
  英語: { EN: "English", 中文: "英语", 한국어: "영어" },
  中国語: { EN: "Chinese", 中文: "中文", 한국어: "중국어" },
  "中国語（標準中国語）": {
    EN: "Chinese (Mandarin)",
    中文: "中文（普通话）",
    한국어: "중국어(표준중국어)",
  },
  韓国語: { EN: "Korean", 中文: "韩语", 한국어: "한국어" },
  雰囲気: { EN: "Mood", 中文: "氛围", 한국어: "분위기" },
  ホテル: { EN: "Hotel", 中文: "酒店", 한국어: "호텔" },
  おすすめ: { EN: "Recommended", 中文: "推荐", 한국어: "추천" },
  撮影: { EN: "Photo Tip", 中文: "拍摄", 한국어: "촬영" },
  撮影ポイント: { EN: "Photo Tip", 中文: "拍摄重点", 한국어: "촬영 포인트" },
  撮影時間: { EN: "Best Time", 中文: "拍摄时间", 한국어: "촬영 시간" },
  ポイント: { EN: "Point", 中文: "重点", 한국어: "포인트" },
  注意: { EN: "Note", 中文: "注意", 한국어: "주의" },
  移動: { EN: "Transport", 中文: "移动", 한국어: "이동" },
  体験: { EN: "Experience", 中文: "体验", 한국어: "체험" },
  行き先: { EN: "Destination", 中文: "目的地", 한국어: "목적지" },
  所要時間: { EN: "Duration", 中文: "所需时间", 한국어: "소요 시간" },
  対象: { EN: "For", 中文: "适合", 한국어: "대상" },
  予約: { EN: "Reservation", 中文: "预约", 한국어: "예약" },
  お子様OK: { EN: "Children OK", 中文: "儿童可参加", 한국어: "어린이 OK" },
  当日予約OK: {
    EN: "Same-day booking OK",
    中文: "可当天预约",
    한국어: "당일 예약 OK",
  },
  料金: { EN: "Price", 中文: "价格", 한국어: "요금" },
  レストラン: { EN: "Restaurant", 中文: "餐厅", 한국어: "레스토랑" },
  バー: { EN: "Bar", 中文: "酒吧", 한국어: "바" },
  "Wi-Fi": { EN: "Wi-Fi", 中文: "Wi-Fi", 한국어: "Wi-Fi" },
  BBQ: { EN: "BBQ", 中文: "烧烤", 한국어: "바비큐" },
  データ: { EN: "Data", 中文: "数据", 한국어: "데이터" },
  含まれるもの: { EN: "Included", 中文: "包含", 한국어: "포함 사항" },
  集合: { EN: "Meeting", 中文: "集合", 한국어: "집합" },
  時間: { EN: "Time", 中文: "时间", 한국어: "시간" },
  受け渡し: { EN: "Delivery", 中文: "交付", 한국어: "전달" },
  Instagram: { EN: "Instagram", 中文: "Instagram", 한국어: "Instagram" },
  撮影オプション: {
    EN: "Shooting Option",
    中文: "拍摄选项",
    한국어: "촬영 옵션",
  },
  要確認: { EN: "Please check", 中文: "请确认", 한국어: "확인 필요" },
  なし: { EN: "None", 中文: "无", 한국어: "없음" },
  不定休: { EN: "Irregular holidays", 中文: "不定休", 한국어: "비정기 휴무" },
  火曜日: { EN: "Tuesday", 中文: "星期二", 한국어: "화요일" },
  水曜日: { EN: "Wednesday", 中文: "星期三", 한국어: "수요일" },
  木曜日: { EN: "Thursday", 中文: "星期四", 한국어: "목요일" },
  月曜日: { EN: "Monday", 中文: "星期一", 한국어: "월요일" },
  土曜日: { EN: "Saturday", 中文: "星期六", 한국어: "토요일" },
  年中無休: { EN: "Open year-round", 中文: "全年无休", 한국어: "연중무휴" },
  変更の場合あり: { EN: "May change", 中文: "可能变更", 한국어: "변更 가능" },
  完売次第終了: {
    EN: "Until sold out",
    中文: "售完即止",
    한국어: "품절 시 종료",
  },
  売切次第終了: {
    EN: "Until sold out",
    中文: "售完即止",
    한국어: "품절 시 종료",
  },
  なくなり次第終了: {
    EN: "Until sold out",
    中文: "售完即止",
    한국어: "소진 시 종료",
  },
  "営業日・時間はInstagramで要確認": {
    EN: "Check Instagram for opening days and hours",
    中文: "营业日与时间请确认Instagram",
    한국어: "영업일과 시간은 Instagram에서 확인",
  },
  ランチ: { EN: "Lunch", 中文: "午餐", 한국어: "점심" },
  カフェタイム: { EN: "Cafe time", 中文: "咖啡时间", 한국어: "카페 타임" },
  ゆっくり過ごす: { EN: "Relax", 中文: "慢慢放松", 한국어: "여유롭게 보내기" },
  ドリンク: { EN: "Drinks", 中文: "饮品", 한국어: "음료" },
  南国ドリンク: {
    EN: "Tropical drinks",
    中文: "南国饮品",
    한국어: "남국 음료",
  },
  スイーツ: { EN: "Sweets", 中文: "甜点", 한국어: "디저트" },
  ジェラート: { EN: "Gelato", 中文: "意式冰淇淋", 한국어: "젤라토" },
  アイスクリーム: { EN: "Ice cream", 中文: "冰淇淋", 한국어: "아이스크림" },
  テイクアウト: { EN: "Takeout", 中文: "外带", 한국어: "테이크아웃" },
  カレー: { EN: "Curry", 中文: "咖喱", 한국어: "카레" },
  スパイスランチ: {
    EN: "Spice lunch",
    中文: "香料午餐",
    한국어: "스파이스 점심",
  },
  ラーメン: { EN: "Ramen", 中文: "拉面", 한국어: "라멘" },
  つけ麺: { EN: "Tsukemen", 中文: "沾面", 한국어: "츠케멘" },
  定食: { EN: "Set meal", 中文: "定食", 한국어: "정식" },
  手作りごはん: { EN: "Homemade meal", 中文: "手作餐", 한국어: "수제 식사" },
  宮古牛バーガー: {
    EN: "Miyako beef burger",
    中文: "宫古牛汉堡",
    한국어: "미야코규 버거",
  },
  ガーリックシュリンプ: {
    EN: "Garlic shrimp",
    中文: "蒜香虾",
    한국어: "갈릭 쉬림프",
  },
  グリル料理: { EN: "Grilled dishes", 中文: "烧烤料理", 한국어: "그릴 요리" },
  肉ランチ: { EN: "Meat lunch", 中文: "肉类午餐", 한국어: "고기 점심" },
  宮古そば: { EN: "Miyako soba", 中文: "宫古荞麦面", 한국어: "미야코 소바" },
  ソーキそば: { EN: "Soki soba", 中文: "软骨肉荞麦面", 한국어: "소키 소바" },
  食堂メニュー: {
    EN: "Local diner menu",
    中文: "食堂菜单",
    한국어: "식당 메뉴",
  },
  ゆし豆腐そば: {
    EN: "Yushi tofu soba",
    中文: "豆腐荞麦面",
    한국어: "유시두부 소바",
  },
  サーターアンダギー: {
    EN: "Sata andagi",
    中文: "萨塔安达吉",
    한국어: "사타안다기",
  },
  紅芋ぱんびん: {
    EN: "Purple sweet potato panbin",
    中文: "紫薯panbin",
    한국어: "자색고구마 판빈",
  },
  さたぱんびんアイス: {
    EN: "Satapanbin ice cream",
    中文: "satapanbin冰淇淋",
    한국어: "사타판빈 아이스크림",
  },
  惣菜: { EN: "Deli foods", 中文: "熟食", 한국어: "반찬" },
  ローカルおやつ: { EN: "Local snacks", 中文: "当地点心", 한국어: "로컬 간식" },
  写真撮影: { EN: "Photography", 中文: "拍照", 한국어: "사진 촬영" },
  雨宿り: { EN: "Shelter from rain", 中文: "避雨", 한국어: "비 피하기" },
  市街地: { EN: "City area", 中文: "市区", 한국어: "시내" },
  朝カフェ: { EN: "Morning cafe", 中文: "早晨咖啡馆", 한국어: "아침 카페" },
  お土産: { EN: "Souvenirs", 中文: "伴手礼", 한국어: "기념품" },
  プール: { EN: "Pool", 中文: "泳池", 한국어: "수영장" },
  リゾート: { EN: "Resort", 中文: "度假感", 한국어: "리조트" },
  開放感: { EN: "Open atmosphere", 中文: "开阔感", 한국어: "개방감" },
  ランチプレート: { EN: "Lunch plate", 中文: "午餐盘", 한국어: "런치 플레이트" },
  海景色: { EN: "Ocean view", 中文: "海景", 한국어: "바다 전망" },
  テラス: { EN: "Terrace", 中文: "露台", 한국어: "테라스" },
  休憩: { EN: "Break", 中文: "休息", 한국어: "휴식" },
  海を見ながら休憩: {
    EN: "Relax while looking at the ocean",
    中文: "一边看海一边休息",
    한국어: "바다를 보며 쉬기",
  },
  カフェ休憩: { EN: "Cafe break", 中文: "咖啡休息", 한국어: "카페 휴식" },
  池間島ドライブ: { EN: "Ikema Island drive", 中文: "池间岛自驾", 한국어: "이케마섬 드라이브" },
  南国フルーツ: { EN: "Tropical fruit", 中文: "南国水果", 한국어: "남국 과일" },
  島食材: { EN: "Island ingredients", 中文: "岛食材", 한국어: "섬 식재료" },
  マンゴースイーツ: { EN: "Mango sweets", 中文: "芒果甜点", 한국어: "망고 디저트" },
  ドライブ休憩: { EN: "Drive break", 中文: "自驾休息", 한국어: "드라이브 휴식" },
  ジャングル感: { EN: "Jungle mood", 中文: "丛林感", 한국어: "정글 분위기" },
  個性派: { EN: "Unique", 中文: "个性风格", 한국어: "개성 있는 분위기" },
  古民家風: { EN: "Old-house style", 中文: "古民家风格", 한국어: "고민가풍" },
  静か: { EN: "Quiet", 中文: "安静", 한국어: "조용함" },
  穴場: { EN: "Hidden spot", 中文: "小众地点", 한국어: "숨은 명소" },
  落ち着いた店内: { EN: "Calm interior", 中文: "安静店内", 한국어: "차분한 실내" },
  コーヒー: { EN: "Coffee", 中文: "咖啡", 한국어: "커피" },
  カフェ作業: { EN: "Work-friendly cafe", 中文: "适合办公的咖啡馆", 한국어: "카페 작업" },
  バーガー: { EN: "Burger", 中文: "汉堡", 한국어: "버거" },
  カジュアル: { EN: "Casual", 中文: "休闲", 한국어: "캐주얼" },
  人気店: { EN: "Popular shop", 中文: "人气店", 한국어: "인기점" },
  海近く: { EN: "Near the beach", 中文: "靠近海边", 한국어: "바다 근처" },
  立ち寄りやすい: { EN: "Easy to stop by", 中文: "方便顺路去", 한국어: "들르기 쉬움" },
  "プールや南国感のある背景を入れて撮ると映えやすい": {
    EN: "Use the pool or tropical background to make the photo stand out.",
    中文: "把泳池或南国感背景拍进去，会更容易出片。",
    한국어: "수영장이나 남국 느낌의 배경을 넣으면 사진이 더 예쁘게 나옵니다.",
  },
  "海を背景に、ドリンクや料理を手前に置いて撮る": {
    EN: "Place drinks or food in the foreground with the ocean behind.",
    中文: "以大海为背景，把饮品或料理放在前景拍摄。",
    한국어: "바다를 배경으로 음료나 음식을 앞쪽에 두고 촬영하세요.",
  },
  "海を背景にジェラートを手前に入れる": {
    EN: "Put the gelato in the foreground with the ocean behind.",
    中文: "把意式冰淇淋放在前景，以大海作为背景。",
    한국어: "젤라토를 앞에 두고 바다를 배경으로 담아보세요.",
  },
  "マンゴーや南国ドリンクを手前に入れて撮る": {
    EN: "Put mango or tropical drinks in the foreground.",
    中文: "把芒果或南国饮品放在前景拍摄。",
    한국어: "망고나 남국 음료를 앞쪽에 두고 촬영하세요.",
  },
  "ブランコ席や緑を背景に撮る": {
    EN: "Use the swing seats or greenery as the background.",
    中文: "利用秋千座位或绿意作为背景拍摄。",
    한국어: "그네 좌석이나 초록 배경을 활용해 촬영하세요.",
  },
  "古民家の雰囲気と料理を一緒に撮る": {
    EN: "Capture the old-house atmosphere together with the food.",
    中文: "把古民家氛围和料理一起拍进去。",
    한국어: "고민가 분위기와 음식을 함께 담아보세요.",
  },
  "カップや店内の雰囲気を寄りで撮る": {
    EN: "Shoot close-ups of the cup and calm interior.",
    中文: "近距离拍摄杯子和店内氛围。",
    한국어: "컵과 실내 분위기를 가까이서 담아보세요.",
  },
  "バーガーを寄りで撮ってボリューム感を出す": {
    EN: "Shoot the burger close-up to show its volume.",
    中文: "近距离拍汉堡，突出份量感。",
    한국어: "버거를 가까이 찍어 볼륨감을 살려보세요.",
  },
  "カラフルなアイスを手前に入れて撮る": {
    EN: "Place colorful ice cream in the foreground.",
    中文: "把彩色冰淇淋放在前景拍摄。",
    한국어: "컬러풀한 아이스크림을 앞쪽에 두고 촬영하세요.",
  },
};

const splitDelimiters = [" / ", "、", "・"];

const translatePhrase = (value, lang) => {
  if (lang === "JP" || typeof value !== "string") {
    return value;
  }

  if (phraseTranslations[value]?.[lang]) {
    return phraseTranslations[value][lang];
  }

  for (const delimiter of splitDelimiters) {
    if (value.includes(delimiter)) {
      return value
        .split(delimiter)
        .map((part) => translatePhrase(part.trim(), lang))
        .join(delimiter);
    }
  }

  return value;
};

const carMinutesLabel = (minutes, lang) => {
  if (lang === "EN") return `about ${minutes} min by car`;
  if (lang === "中文") return `开车约${minutes}分钟`;
  if (lang === "한국어") return `차로 약 ${minutes}분`;
  return `車で約${minutes}分`;
};

const translateNearestAirport = (value, lang) => {
  if (lang === "JP" || typeof value !== "string") {
    return value;
  }

  const match = value.match(/^(.+?)[（(](.+)[）)]$/);
  if (!match) {
    return translatePhrase(value, lang);
  }

  const [, airportName, detail] = match;
  const translatedAirport = translatePhrase(airportName, lang);

  const carMatch = detail.match(/^車で約(\d+)分$/);
  if (carMatch) {
    return `${translatedAirport}（${carMinutesLabel(carMatch[1], lang)}）`;
  }

  const kmMatch = detail.match(/^([\d.]+)km$/);
  if (kmMatch) {
    return `${translatedAirport}（${kmMatch[1]}km）`;
  }

  return `${translatedAirport}（${detail}）`;
};

const hasJapaneseText = (value) =>
  typeof value === "string" && /[ぁ-んァ-ン一-龥]/.test(value);

const getLocalizedLongText = (value, lang = "JP", fallback = "") => {
  const localizedValue = getLocalizedValue(value, lang);

  if (
    lang !== "JP" &&
    localizedValue === value &&
    hasJapaneseText(localizedValue) &&
    localizedValue.length > 24
  ) {
    return fallback;
  }

  return localizedValue;
};

const makeShopFallbackText = (shop, lang) => {
  if (lang === "JP") return "";

  const name = shop.name || "";
  const area = getLocalizedValue(shop.area, lang);
  const menu = getLocalizedValue(
    shop.recommendedMenu ||
      shop.recommendMenu ||
      shop.menu ||
      shop.orderRecommendation ||
      "",
    lang,
  );

  if (lang === "EN") {
    return `${name} is a recommended stop${area ? ` around ${area}` : ""}${
      menu ? `, especially for ${menu}` : ""
    }. It is a useful place to add to your Miyakojima trip.`;
  }

  if (lang === "中文") {
    return `${name}是${area ? `${area}周边` : "宫古岛"}值得顺路去的店${
      menu ? `，推荐${menu}` : ""
    }。适合加入宫古岛旅行路线。`;
  }

  if (lang === "한국어") {
    return `${name}는 ${area ? `${area} 주변에서` : "미야코지마에서"} 들르기 좋은 곳${
      menu ? `이며, ${menu}를 추천합니다` : "입니다"
    }. 여행 코스에 넣기 좋습니다.`;
  }

  return "";
};

const makePointFallbackText = (point, lang) => {
  if (lang === "JP") return "";

  const title = getLocalizedValue(point.title, lang);
  const area = getLocalizedValue(point.area, lang);

  if (lang === "EN") {
    return `${title}${area ? ` around ${area}` : ""} is one of the recommended ways to enjoy Miyakojima.`;
  }

  if (lang === "中文") {
    return `${title}${area ? `（${area}）` : ""}是享受宫古岛旅行的推荐方式之一。`;
  }

  if (lang === "한국어") {
    return `${title}${area ? ` (${area})` : ""}는 미야코지마 여행에서 추천하는 즐길 거리입니다.`;
  }

  return "";
};

const makeSpotFallbackText = (spot, lang) => {
  if (lang === "JP") return "";

  const title = getLocalizedValue(spot.title, lang);
  const area = getLocalizedValue(spot.area, lang);

  if (lang === "EN") {
    return `${title} is a scenic spot${area ? ` in ${area}` : ""} that is worth visiting during a Miyakojima trip.`;
  }

  if (lang === "中文") {
    return `${title}${area ? `位于${area}` : ""}，是宫古岛旅行中值得前往的景点。`;
  }

  if (lang === "한국어") {
    return `${title}${area ? ` (${area})` : ""}는 미야코지마 여행 중 들르기 좋은 경치 좋은 장소입니다.`;
  }

  return "";
};

const isLocalizedTextMap = (value) => {
  if (!value || Array.isArray(value) || typeof value !== "object") {
    return false;
  }

  return ["JP", "EN", "中文", "한국어"].some((lang) =>
    Object.prototype.hasOwnProperty.call(value, lang),
  );
};

export const getLocalizedValue = (value, lang = "JP") => {
  if (!isLocalizedTextMap(value)) {
    if (lang !== "JP" && typeof value === "string") {
      return translatePhrase(value, lang);
    }

    return value;
  }

  return (
    value[lang] ||
    value.JP ||
    value.EN ||
    value["中文"] ||
    value["한국어"] ||
    ""
  );
};

const localizeList = (items, lang) => {
  if (!Array.isArray(items)) {
    return items;
  }

  return items.map((item) => getLocalizedValue(item, lang));
};

const localizeRows = (rows, lang) => {
  if (!Array.isArray(rows)) {
    return rows;
  }

  return rows
    .map((row) =>
      Array.isArray(row)
        ? row.map((item, index) =>
            index === 1
              ? getLocalizedLongText(item, lang)
              : getLocalizedValue(item, lang),
          )
        : getLocalizedValue(row, lang),
    )
    .filter((row) => !Array.isArray(row) || row.every(Boolean));
};

export const localizeShop = (shop, lang) => ({
  ...shop,
  name: getLocalizedValue(shop.name, lang),
  area: getLocalizedValue(shop.area, lang),
  text: getLocalizedLongText(shop.text, lang, makeShopFallbackText(shop, lang)),
  genre: getLocalizedValue(shop.genre, lang),
  type: getLocalizedValue(shop.type, lang),
  recommendedMenu: getLocalizedValue(shop.recommendedMenu, lang),
  recommendMenu: getLocalizedValue(shop.recommendMenu, lang),
  menu: getLocalizedValue(shop.menu, lang),
  orderRecommendation: getLocalizedValue(shop.orderRecommendation, lang),
  businessHours: getLocalizedValue(shop.businessHours, lang),
  openingHours: getLocalizedValue(shop.openingHours, lang),
  hours: getLocalizedValue(shop.hours, lang),
  closedDays: getLocalizedValue(shop.closedDays, lang),
  regularHoliday: getLocalizedValue(shop.regularHoliday, lang),
  holiday: getLocalizedValue(shop.holiday, lang),
  instagramLabel: getLocalizedValue(shop.instagramLabel, lang),
  websiteLabel: getLocalizedValue(shop.websiteLabel, lang),
  nearestAirport: isLocalizedTextMap(shop.nearestAirport)
    ? getLocalizedValue(shop.nearestAirport, lang)
    : translateNearestAirport(shop.nearestAirport, lang),
  facilities: localizeList(shop.facilities, lang),
  languages: localizeList(shop.languages, lang),
  rows: localizeRows(shop.rows, lang),
  hashtags: getLocalizedTags(shop.hashtags, lang),
});

const localizeSpot = (spot, lang) => ({
  ...spot,
  title: getLocalizedValue(spot.title, lang),
  area: getLocalizedValue(spot.area, lang),
  text: getLocalizedLongText(spot.text, lang, makeSpotFallbackText(spot, lang)),
  rows: localizeRows(spot.rows, lang),
  hashtags: getLocalizedTags(spot.hashtags, lang),
});

const mergeLocalizedValue = (originalValue, translatedValue) => {
  if (translatedValue === undefined) {
    return originalValue;
  }

  if (isLocalizedTextMap(translatedValue)) {
    return {
      JP: isLocalizedTextMap(originalValue)
        ? getLocalizedValue(originalValue, "JP")
        : originalValue,
      ...translatedValue,
    };
  }

  return translatedValue;
};

const mergeLocalizedObject = (originalObject, translatedObject, fields) => {
  if (!originalObject && !translatedObject) {
    return originalObject;
  }

  const mergedObject = {
    ...(originalObject || {}),
    ...(translatedObject || {}),
  };

  fields.forEach((field) => {
    mergedObject[field] = mergeLocalizedValue(
      originalObject?.[field],
      translatedObject?.[field],
    );
  });

  return mergedObject;
};

const mergeLocalizedRows = (originalRows, translatedRows) => {
  if (!Array.isArray(originalRows) || !Array.isArray(translatedRows)) {
    return translatedRows || originalRows;
  }

  return originalRows.map((row, index) => {
    const translatedRow = translatedRows[index];

    if (!Array.isArray(row) || !Array.isArray(translatedRow)) {
      return mergeLocalizedValue(row, translatedRow);
    }

    return row.map((item, itemIndex) =>
      mergeLocalizedValue(item, translatedRow[itemIndex]),
    );
  });
};

const mergeLocalizedCollection = (items, translations, fields) => {
  if (!Array.isArray(items)) {
    return items;
  }

  const itemTranslations = Array.isArray(translations) ? translations : [];

  return items.map((item, index) => {
    const itemTranslation = itemTranslations[index] || {};
    const mergedItem = {
      ...item,
      ...itemTranslation,
    };

    fields.forEach((field) => {
      mergedItem[field] = mergeLocalizedValue(
        item[field],
        itemTranslation[field],
      );
    });

    if (item.rows || itemTranslation.rows) {
      mergedItem.rows = mergeLocalizedRows(item.rows, itemTranslation.rows);
    }

    if (item.shops || itemTranslation.shops) {
      mergedItem.shops = mergeLocalizedCollection(
        item.shops,
        itemTranslation.shops,
        [
          "name",
          "area",
          "text",
          "genre",
          "type",
          "recommendedMenu",
          "recommendMenu",
          "menu",
          "orderRecommendation",
          "businessHours",
          "openingHours",
          "hours",
          "closedDays",
          "regularHoliday",
          "holiday",
          "instagramLabel",
          "websiteLabel",
          "nearestAirport",
          "facilities",
          "languages",
        ],
      );
    }

    return mergedItem;
  });
};

export const withArticleTranslations = (article) => {
  const translations = blogArticleTranslations[article.slug];

  if (!translations) {
    return article;
  }

  return {
    ...article,
    category: mergeLocalizedValue(article.category, translations.category),
    title: mergeLocalizedValue(article.title, translations.title),
    text: mergeLocalizedValue(article.text, translations.text),
    description: mergeLocalizedValue(
      article.description,
      translations.description,
    ),
    leadText: mergeLocalizedValue(article.leadText, translations.leadText),
    youtubeTitle: mergeLocalizedValue(
      article.youtubeTitle,
      translations.youtubeTitle,
    ),
    toc: mergeLocalizedValue(article.toc, translations.toc),
    cta: mergeLocalizedObject(article.cta, translations.cta, [
      "title",
      "text",
      "buttonText",
    ]),
    guideInstagram: mergeLocalizedObject(
      article.guideInstagram,
      translations.guideInstagram,
      ["title", "text", "cta"],
    ),
    points: mergeLocalizedCollection(article.points, translations.points, [
      "title",
      "area",
      "text",
    ]),
    spots: mergeLocalizedCollection(article.spots, translations.spots, [
      "title",
      "area",
      "text",
    ]),
  };
};

export const localizeCategoryItems = (items = [], lang = "JP") =>
  items.map((item) => ({
    ...item,
    label: getLocalizedValue(item.label, lang),
  }));

export const localizeTagItems = (items = [], lang = "JP") =>
  items.map((item) => ({
    ...item,
    label: isLocalizedTextMap(item.label)
      ? getLocalizedValue(item.label, lang)
      : getLocalizedTag(item.label || item.key, lang),
  }));

export const localizeArticle = (article, lang = "JP") => {
  if (!article) {
    return article;
  }

  const translatedArticle = withArticleTranslations(article);
  const translatedToc = getLocalizedValue(translatedArticle.toc, lang);

  return {
    ...translatedArticle,
    category: getLocalizedValue(translatedArticle.category, lang),
    title: getLocalizedValue(translatedArticle.title, lang),
    text: getLocalizedValue(translatedArticle.text, lang),
    description: getLocalizedValue(translatedArticle.description, lang),
    leadText: getLocalizedValue(translatedArticle.leadText, lang),
    youtubeTitle: getLocalizedValue(translatedArticle.youtubeTitle, lang),
    toc: localizeList(translatedToc, lang),
    tags: getLocalizedTags(translatedArticle.tags, lang),
    cta: translatedArticle.cta
      ? {
          ...translatedArticle.cta,
          title: getLocalizedValue(translatedArticle.cta.title, lang),
          text: getLocalizedValue(translatedArticle.cta.text, lang),
          buttonText: getLocalizedValue(translatedArticle.cta.buttonText, lang),
        }
      : translatedArticle.cta,
    guideInstagram: translatedArticle.guideInstagram
      ? {
          ...translatedArticle.guideInstagram,
          title: getLocalizedValue(
            translatedArticle.guideInstagram.title,
            lang,
          ),
          text: getLocalizedValue(translatedArticle.guideInstagram.text, lang),
          cta: getLocalizedValue(translatedArticle.guideInstagram.cta, lang),
        }
      : translatedArticle.guideInstagram,
    points: Array.isArray(translatedArticle.points)
      ? translatedArticle.points.map((point) => ({
          ...point,
          title: getLocalizedValue(point.title, lang),
          area: getLocalizedValue(point.area, lang),
          text: getLocalizedLongText(
            point.text,
            lang,
            makePointFallbackText(point, lang),
          ),
          rows: localizeRows(point.rows, lang),
          hashtags: getLocalizedTags(point.hashtags, lang),
          shops: Array.isArray(point.shops)
            ? point.shops.map((shop) => localizeShop(shop, lang))
            : point.shops,
        }))
      : translatedArticle.points,
    spots: Array.isArray(translatedArticle.spots)
      ? translatedArticle.spots.map((spot) => localizeSpot(spot, lang))
      : translatedArticle.spots,
  };
};

export const localizeArticleList = (articles = [], lang = "JP") =>
  articles.map((article) => localizeArticle(article, lang));
